import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export const setIsOptionalExperiencesPolicyEnabledMutator: (
    isOptionalConnectedExperiencesPolicyEnabled: boolean | undefined
) => void = mutatorAction(
    'setIsOptionalExperiencesPolicyEnabledMutator',
    (isOptionalConnectedExperiencesPolicyEnabled: boolean | undefined) => {
        getStore().isOptionalConnectedExperiencesPolicyEnabled =
            isOptionalConnectedExperiencesPolicyEnabled;
    }
);
